import React, { useState } from "react";
import { Form, Button } from "react-bootstrap";
import AddDesignatedModal from "../AddDesignatedModal/AddDesignatedModal";

const EventModal = ({
  show,
  onClose,
  onCreate,
  titleValue,
  onTitleChange,
  dateValue,
  onDateChange,
  typeValue,
  onTypeChange,
  priorityValue,
  onPriorityChange,
  allDay,
  setAllDay,
  typeOptions,
  priorityOptions,
  userList,
}) => {
  const [designatedModalOpen, setDesignatedModalOpen] = useState(false);
  const [selectedDesignados, setSelectedDesignados] = useState([]);

  const handleOpenDesignatedModal = () => {
    setDesignatedModalOpen(true);
  };

  const handleCloseDesignatedModal = () => {
    setDesignatedModalOpen(false);
  };

  const handleSaveDesignados = (designados) => {
    setSelectedDesignados(designados);
    setDesignatedModalOpen(false);
  };

  if (!show) return null;

  return (
    <>
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.5)",
          zIndex: 1040,
        }}
        onClick={onClose}
      ></div>

      <div
        className="modal fade show d-block"
        tabIndex="-1"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 1050,
          backgroundColor: "#17296B",
          borderRadius: "8px",
          padding: "16px",
          width: "500px",
          maxHeight: "60vh",
          overflowY: "auto",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <div className="modal-header d-flex justify-content-between align-items-center px-3">
          <div className="d-flex align-items-center gap-2">
            <div
              style={{
                width: "4px",
                height: "24px",
                backgroundColor: "#0d6efd",
                borderRadius: "2px",
              }}
            ></div>
            <h5 className="modal-title fs-5 text-white mb-0">
              Novo Evento
            </h5>
          </div>
          <div className="d-flex gap-2">
            <Button
              variant="primary"
              onClick={onCreate}
              style={{
                backgroundColor: "#0d6efd",
                border: "none",
              }}
            >
              Criar
            </Button>
            <Button
              onClick={onClose}
              style={{
                backgroundColor: "#0d6efd",
                border: "none",
              }}
            >
              X
            </Button>
          </div>
        </div>
        <div className="modal-body">
          <Form>
            <Form.Group className="mb-2">
              <Form.Label className="text-white">Título</Form.Label>
              <Form.Control
                type="text"
                value={titleValue}
                onChange={onTitleChange}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label className="text-white">Data</Form.Label>
              <Form.Control
                type={allDay ? "date" : "datetime-local"}
                value={dateValue}
                onChange={onDateChange}
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Check
                type="checkbox"
                label="Dia Inteiro"
                checked={allDay}
                onChange={(e) => setAllDay(e.target.checked)}
                className="text-white"
              />
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label className="text-white">Tipo</Form.Label>
              <Form.Select value={typeValue} onChange={onTypeChange}>
                <option value="">Selecionar tipo</option>
                {typeOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label className="text-white">Prioridade</Form.Label>
              <Form.Select value={priorityValue} onChange={onPriorityChange}>
                <option value="">Selecionar prioridade</option>
                {priorityOptions.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <Form.Group className="mb-2">
              <Form.Label className="text-white">Designados</Form.Label>
              <div className="d-flex flex-wrap gap-2">
                {selectedDesignados.map((user) => (
                  <img
                    key={user.id}
                    src={user.avatar}
                    alt={`Avatar de ${user.name}`}
                    className="rounded-circle"
                    style={{
                      width: "40px",
                      height: "40px",
                      objectFit: "cover",
                      border: "2px solid white",
                    }}
                  />
                ))}
                <Button
                  variant="outline-light"
                  size="sm"
                  style={{
                    width: 40,
                    height: 40,
                    padding: 0,
                    fontWeight: "bold",
                    fontSize: "1.2rem",
                    lineHeight: 1,
                    borderRadius: "50%",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                  onClick={handleOpenDesignatedModal}
                  title="Adicionar Designados"
                >
                  +
                </Button>
              </div>
            </Form.Group>
          </Form>
        </div>
      </div>

      <AddDesignatedModal
        show={designatedModalOpen}
        onClose={handleCloseDesignatedModal}
        userList={userList}
        onSave={handleSaveDesignados}
        selectedDesignados={selectedDesignados}
      />
    </>
  );
};

export default EventModal;
